<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
  >
    <path
      d="M13.3346 8.33399V4.53399C13.3346 3.41388 13.3346 2.85383 13.1166 2.426C12.9249 2.04968 12.6189 1.74372 12.2426 1.55197C11.8148 1.33398 11.2547 1.33398 10.1346 1.33398H5.86797C4.74786 1.33398 4.18781 1.33398 3.75999 1.55197C3.38366 1.74372 3.0777 2.04968 2.88596 2.426C2.66797 2.85383 2.66797 3.41388 2.66797 4.53399V11.4673C2.66797 12.5874 2.66797 13.1475 2.88596 13.5753C3.0777 13.9516 3.38366 14.2576 3.75999 14.4493C4.18781 14.6673 4.74783 14.6673 5.86787 14.6673H8.33464M9.33464 7.33399H5.33464M6.66797 10.0007H5.33464M10.668 4.66732H5.33464"
      :stroke="color"
      stroke-width="1.17333"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M12 14.667L14 12.667M14 12.667L12 10.667M14 12.667L10 12.667"
      :stroke="color"
      stroke-width="1.17333"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>

<script setup>
defineProps({
  color: {
    type: String,
    default: "#475467",
  },
});
</script>
